// @flow
import { defaultStateDataCurrent, type StateDataCurrent } from 'app/common/ui-components/filter';


const customerSearchItems = (): [Array<any>, StateDataCurrent] => (
  [[], defaultStateDataCurrent]
);

export default customerSearchItems;
